/**
 * EntityApiKeys API - Auto-generated typed wrapper.
 * DO NOT EDIT - Regenerate with: bun run generate
 * @generated
 */

import {
  createEntityApiKey,
  deleteEntityApiKey,
  listEntityApiKeys,
} from "../generated/entity-api-keys/entity-api-keys";

import { wrapMethod } from "./utils";

export const entityApiKeys = {
  /** @see listEntityApiKeys */
  listEntityApiKeys: wrapMethod(listEntityApiKeys),

  /** @see createEntityApiKey */
  create: wrapMethod(createEntityApiKey),

  /** @see deleteEntityApiKey */
  delete: wrapMethod(deleteEntityApiKey),
} as const;

export type EntityApiKeysApi = typeof entityApiKeys;
